import React from 'react';
import { motion } from 'framer-motion';
import LocationIcon from '../components/common/LocationIcon';
import ContactForm from '../components/contact/ContactForm';
import './Home.css';

const Contact = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="contact-hero-section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="section-title">Contact Us</h1>
            <p className="section-subtitle">
              Get in touch for your construction and real estate needs
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="contact-info-section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Contact Information</h2>
            <p className="section-subtitle">
              Reach out to us through any of the following channels
            </p>
          </motion.div>

          <div className="horizontal-contact-row">
            <motion.div
              className="contact-card"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              whileHover={{
                y: -8,
                boxShadow: 'var(--shadow-2xl)',
                transition: { duration: 0.3 }
              }}
            >
              <div className="contact-card-header">
                <div className="contact-icon">🏢</div>
                <h3 className="contact-card-title">Corporate Office</h3>
              </div>
              <div className="contact-card-content">
                <p><strong>Vibha Corporation & Co</strong></p>
                <p>Old No: 50, New No:8 Plot No :12, Niramaya Flats, 3rd floor, Janakiraman Street, West Mambalam, Chennai-600033</p>
              </div>
            </motion.div>

            <motion.div
              className="contact-card"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              viewport={{ once: true }}
              whileHover={{
                y: -8,
                boxShadow: 'var(--shadow-2xl)',
                transition: { duration: 0.3 }
              }}
            >
              <div className="contact-card-header">
                <div className="contact-icon">🏠</div>
                <h3 className="contact-card-title">Registered Office</h3>
              </div>
              <div className="contact-card-content">
                <p><strong>Vibha Corporation & Co</strong></p>
                <p>Plot No 9, Door No 10, Vasudhaalayam, Lakshmi Hayagreeva Nagar, 4th Cross Street, Adambakkam, Chennai-600088</p>
              </div>
            </motion.div>

            <motion.div
              className="contact-card"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
              whileHover={{
                y: -8,
                boxShadow: 'var(--shadow-2xl)',
                transition: { duration: 0.3 }
              }}
            >
              <div className="contact-card-header">
                <div className="contact-icon">
                  <LocationIcon title="Service locations" />
                </div>
                <h3 className="contact-card-title">Services Available In</h3>
              </div>
              <div className="contact-card-content">
                <p>Chennai | Coimbatore | Coonoor | Kodaikanal | Madurai | Trichy | Pondicherry</p>
              </div>
            </motion.div>

            <motion.div
              className="contact-card"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              viewport={{ once: true }}
              whileHover={{
                y: -8,
                boxShadow: 'var(--shadow-2xl)',
                transition: { duration: 0.3 }
              }}
            >
              <div className="contact-card-header">
                <div className="contact-icon">🕐</div>
                <h3 className="contact-card-title">Business Hours</h3>
              </div>
              <div className="contact-card-content">
                <p>Monday - Saturday: 9:00 AM - 6:00 PM</p>
                <p>Sunday: By Appointment</p>
              </div>
            </motion.div>

            <motion.div
              className="contact-card"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              viewport={{ once: true }}
              whileHover={{
                y: -8,
                boxShadow: 'var(--shadow-2xl)',
                transition: { duration: 0.3 }
              }}
            >
              <div className="contact-card-header">
                <div className="contact-icon">📞</div>
                <h3 className="contact-card-title">Connect With Us</h3>
              </div>
              <div className="contact-card-content">
                <p><strong>Ramsharan S</strong> - Manager Business Operations and Development<br />
                <a href="tel:7358666389" className="contact-link">7358666389</a></p>
                <p><strong>Dinesh Kumar</strong> - Projects Head<br />
                <a href="tel:8870432644" className="contact-link">8870432644</a></p>
                <p><strong>Sundar Rajan Jagannathan</strong> - Managing Partner<br />
                <a href="tel:9884875641" className="contact-link">9884875641</a></p>
                <p style={{ marginTop: '1rem' }}>
                  <strong>Contact Email:</strong><br />
                  <a href="mailto:ramsharan@vibhacorporation.in" className="contact-link">ramsharan@vibhacorporation.in</a><br />
                  <a href="mailto:dinesh@vibhacorporation.in" className="contact-link">dinesh@vibhacorporation.in</a><br />
                  <a href="mailto:srj@vibhacorporation.in" className="contact-link">srj@vibhacorporation.in</a>
                </p>
              </div>
            </motion.div>
          </div>

          {/* Horizontal Divider */}
          <motion.div
            className="contact-divider"
            initial={{ opacity: 0, scaleX: 0 }}
            whileInView={{ opacity: 1, scaleX: 1 }}
            transition={{ duration: 0.8, delay: 1.0 }}
            viewport={{ once: true }}
          />
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Send Us a Message</h2>
            <p className="section-subtitle">
              Fill out the form below and we'll get back to you as soon as possible
            </p>
          </motion.div>

          <motion.div
            className="contact-form-wrapper"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <ContactForm />
          </motion.div>
        </div>
      </section>

      {/* Our Commitment Section */}
      <section className="commitment-section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Our Commitment</h2>
            <p className="section-subtitle">
              Building relationships, trust, and lasting value
            </p>
          </motion.div>

          <motion.div
            className="commitment-content"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <p className="commitment-quote">
              "At Vibha Corporation, we don't just build structures; we build relationships, trust, and lasting value. Every project is a testament to our commitment to excellence and our promise to deliver beyond expectations."
            </p>
            <p className="commitment-text">
              Ready to start your next project? Contact us today for a consultation.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
